// extracted by mini-css-extract-plugin
export default {"stackButton":"CollaboratorStack_stackButton__4Ga64","label":"CollaboratorStack_label__GzIYp","stack":"CollaboratorStack_stack__sznZc","avatar":"CollaboratorStack_avatar__Wovyw"};